import { cn } from "~/lib/utils"

function ButtonGroup({ className, ...props }: React.ComponentProps<"div">) {
  return <div role="group" data-slot="button-group" className={cn("h-button-group", className)} {...props} />
}
ButtonGroup.displayName = "ButtonGroup"

export { ButtonGroup }
